import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cart")) || null; } catch { return null; }
  });

  useEffect(() => {
    if (cart) localStorage.setItem("cart", JSON.stringify(cart));
    else localStorage.removeItem("cart");
  }, [cart]);

  const addItem = (shop, product) => {
    const finalPrice = Math.round(product.price * (1 - (product.discount_percent || 0) / 100));
    setCart((prev) => {
      if (prev && prev.shop_id !== shop.id) {
        toast.error("لديك منتجات من متجر آخر. سيتم استبدال السلة.");
        return { shop_id: shop.id, shop_name: shop.name, delivery_fee: shop.delivery_fee ?? 3000,
          items: [{ product_id: product.id, name: product.name, price: finalPrice, qty: 1, image_path: product.image_path }] };
      }
      const base = prev || { shop_id: shop.id, shop_name: shop.name, delivery_fee: shop.delivery_fee ?? 3000, items: [] };
      const existing = base.items.find((i) => i.product_id === product.id);
      let items;
      if (existing) items = base.items.map((i) => i.product_id === product.id ? { ...i, qty: i.qty + 1 } : i);
      else items = [...base.items, { product_id: product.id, name: product.name, price: finalPrice, qty: 1, image_path: product.image_path }];
      return { ...base, items };
    });
    toast.success("أُضيف إلى السلة");
  };

  const setQty = (product_id, qty) => {
    setCart((prev) => {
      if (!prev) return prev;
      let items = prev.items.map((i) => i.product_id === product_id ? { ...i, qty } : i).filter((i) => i.qty > 0);
      if (items.length === 0) return null;
      return { ...prev, items };
    });
  };

  const clearCart = () => setCart(null);

  const count = cart ? cart.items.reduce((s, i) => s + i.qty, 0) : 0;
  const subtotal = cart ? cart.items.reduce((s, i) => s + i.price * i.qty, 0) : 0;

  return (
    <CartContext.Provider value={{ cart, addItem, setQty, clearCart, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
